import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Nav.css";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo / Brand */}
        <div className="logo">
          <Link to="/">Event Registration</Link>
        </div>

        {/* Hamburger Icon */}
        <div className="menu-icon" onClick={() => setIsOpen(!isOpen)}>
          ☰
        </div>

        {/* Nav Links */}
        <ul className={`nav-links ${isOpen ? "active" : ""}`}>
          <li>
            <Link to="/events">Events</Link>
          </li>
          <li>
            <Link to="/admin">Admin</Link>
          </li>
          <li>
            <button className="logout-btn">Logout</button>
          </li>
        </ul>
      </div>
    </nav>
  );
}
